import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Dialog, DialogContent, DialogTitle } from '@material-ui/core';
import Close from '@material-ui/icons/Close';
import Search from '@material-ui/icons/Search';
import { CodeEditor } from './CodeEditor';
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import { CheckIfFlowUpdated } from '../../../helpers/helper';
import { saveAvailable, initialActions, changedFields } from "../../../recoil-store/recoil-state";

function EditorDialog({ action, inputName, variables, language, include, isRequired, setOpen, out_label }) {
    const { t } = useTranslation();
    const label = out_label ? out_label : 'CONTENT.TEXT-EDITOR.';
    const [variable, setVariables] = useState(variables);
    const initialActionsData = useRecoilValue(initialActions);
    const setSaveAvailable = useSetRecoilState(saveAvailable);
    const [changedFieldsState, setChangeFields] = useRecoilState(changedFields);

    const handleAddClick = useRef();
    const handleClick = (item) => {
        handleAddClick.current(item);
    };
    const handleChange = (e) => {
        setVariables(variables?.filter(v => v?.name?.includes(e.target.value)));
    };
    const handleClose = () => {
        const field = initialActionsData[action.id]?.fields[inputName];
        const oldValue = !field ? undefined : field.value;
        let newValue = action.fields[inputName]?.value;

        CheckIfFlowUpdated(inputName, action, oldValue, newValue, setSaveAvailable, setChangeFields, changedFieldsState);
        setOpen(false);
    };
    return (
        <Dialog open={true} onClose={handleClose} fullWidth>
            <DialogTitle>
                <div className="dialog-header">
                    {t(label + 'CODE')}
                    <Button onClick={handleClose}>
                        <Close fontSize="small" />
                    </Button>
                </div>
            </DialogTitle>
            <DialogContent>
                <div className="code-editor">
                    <div className="code-variables">
                        <div className="code-vlabel">{t(label + 'INSERT')}</div>
                        <div className="code-vsearch">
                            <Search fontSize="small" />
                            <input placeholder={t(label + 'SEARCH')} onChange={handleChange} />
                        </div>
                        <div className="code-vlist">
                            {variable?.map((item, itemI) => (
                                <button className="code-variable" key={itemI}
                                    onClick={() => { handleClick(item); }}>
                                    {item.name}
                                </button>
                            ))}
                        </div>
                    </div>
                    <CodeEditor action={action} inputName={inputName} onAddClick={handleAddClick} variables={variables}
                        include={include} isRequired={isRequired} language={language} multiline dialog />
                </div>
            </DialogContent>
        </Dialog>
    );
}
export default EditorDialog;